import React from 'react';
import { styled } from '@compiled/react';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { REPORT } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/app/types.tsx';
import AddDependency from '../add-dependency/index.tsx';
import GroupBy from './group-by/index.tsx';
import IssueLinkTypeFilter from './issue-link-type/index.tsx';
import Issue from './issue/index.tsx';
import ProjectFilter from './project/index.tsx';
import ResetButton from './reset-button/index.tsx';
import RollupFilter from './rollup/index.tsx';
import SprintFilter from './sprint/index.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

export default function Filters({
	issues,
	setIssueFilter,
	setProjectFilter,
	setIssueLinkTypeFilter,
	setSprintFilter,
	setGroupBy,
	setRollUp,
	onFilterChange,
	onDependencyAdded,
	legendToggleButton,
	mode,
}: Props) {
	const getFilterStyle = () => {
		if (mode === REPORT) {
			return styles.dependencyReportMacroContainer;
		}
		return getWillShowNav4() ? styles.containerWithHorizontalNav : styles.container;
	};

	const filtersStyle = getFilterStyle();

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<ul className={filtersStyle}>
			<StyledLi>
				<RollupFilter setRollUp={setRollUp} onFilterChange={onFilterChange} />
			</StyledLi>
			<StyledLi>
				<GroupBy setGroupBy={setGroupBy} onFilterChange={onFilterChange} />
			</StyledLi>
			<StyledLi>
				<ProjectFilter setProjectFilter={setProjectFilter} onFilterChange={onFilterChange} />
			</StyledLi>
			<StyledLi>
				<SprintFilter setSprintFilter={setSprintFilter} onFilterChange={onFilterChange} />
			</StyledLi>
			<StyledLi>
				<Issue setIssueFilter={setIssueFilter} issues={issues} onFilterChange={onFilterChange} />
			</StyledLi>
			<StyledLi>
				<IssueLinkTypeFilter
					setIssueLinkTypeFilter={setIssueLinkTypeFilter}
					onFilterChange={onFilterChange}
				/>
			</StyledLi>
			<StyledLi>
				<ResetButton onFilterChange={onFilterChange} />
			</StyledLi>
			<AddDependencyLi>
				<AddDependency onDependencyAdded={onDependencyAdded} filteredIssues={issues} />
			</AddDependencyLi>
			{legendToggleButton && <LegendLi>{legendToggleButton}</LegendLi>}
		</ul>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLi = styled.li({
	display: 'inline-block',
	margin: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LegendLi = styled.li({
	display: 'flex',
	'justify-content': 'flex-end',
	flex: '1',
	margin: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AddDependencyLi = styled.li({
	display: 'flex',
	'justify-content': 'flex-end',
	'flex-grow': '1',
	margin: 0,
});
